var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "downloadAttachmentsModal",
        "aria-hidden": "true",
        "aria-labelledby": "downloadAttachmentsModal",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _vm._m(0),
              _vm._m(1),
              _c(
                "div",
                {
                  staticClass: "modal-footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: {
                        "data-dismiss": "modal",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadWithoutFiles()
                        },
                      },
                    },
                    [_vm._v(" No ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadFiles()
                        },
                      },
                    },
                    [_vm._v(" Yes ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-header",
      },
      [
        _c(
          "h5",
          {
            staticClass: "modal-title",
            attrs: {
              id: "downloadAttachmentsModal",
            },
          },
          [_vm._v(" Download Attached files ")]
        ),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              "aria-label": "Close",
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [
            _c(
              "span",
              {
                attrs: {
                  "aria-hidden": "true",
                },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-body",
      },
      [
        _c("p", [
          _vm._v(
            "Would you like to download attached files for the selected Budgets?"
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }